import React from 'react';
import ModalDialog from '../ModalDialog';
import ReactHotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';

const NewPatientModalWrapper: React.FC<
    {
        callback?: any;
        close: () => void;
        className: string;
    } & { style?: React.CSSProperties }
> = ({ callback, close, className, children, style }) => {
    return (
        <ModalDialog>
            <ReactHotkeys keyName="esc" onKeyDown={close}>
                <motion.div
                    initial={{ opacity: 0 }}
                    exit={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    style={{ zIndex: callback ? 100 : 20, ...style }}
                    transition={{ duration: 0.2, ease: 'linear' }}
                    className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-lato"
                >
                    <div className="modal-overlay" onClick={close}></div>
                    <div className={className}>{children}</div>
                </motion.div>
            </ReactHotkeys>
        </ModalDialog>
    );
};

export default NewPatientModalWrapper;
